// @ts-nocheck
import React, { Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'antd';
import Layout from './components/Layout/Layout';
import ROUTES from './utils/routes';
import { changeTranslationMode } from './redux/actions/global';

const Mbn = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'Mbn' */
            './components/Templates/MBN/Mbn'
        ),
);

const MarketGroups = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'MarketGroups' */
            './components/Templates/MarketGroups/MarketGroups'
        ),
);

const BetAcceptanceTime = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'BetAcceptanceTime' */
            './components/Templates/BetAcceptanceTime/BetAcceptanceTime'
        ),
);

const CombinationLocks = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'CombinationLocks' */
            './components/Templates/CombinationLocks/CombinationLocks'
        ),
);

const MarketDescriptions = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'MarketDescriptions' */
            './components/Templates/MarketDescriptions/MarketDescriptions'
        ),
);

const Sports = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'Sports' */
            './components/Weight/Sports/Sports'
        ),
);

const Categories = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'Categories' */
            './components/Weight/Categories/Categories'
        ),
);

const Leagues = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'Leagues' */
            './components/Weight/Leagues/Leagues'
        ),
);

const TaxOnTurnoverReport = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'TaxOnTurnoverReport' */
            './components/TaxReport/TaxOnTurnoverReport/TaxOnTurnoverReport'
        ),
);

const TaxOnReturnReport = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'TaxOnReturnReport' */
            './components/TaxReport/TaxOnReturnReport/ TaxOnReturnReport'
        ),
);

const Addresses = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'Addresses' */
            './components/Emails/Addresses/Addresses'
        ),
);

const Groups = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'Groups' */
            './components/Emails/Groups/Groups'
        ),
);

const BetBanners = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'BetBanners' */
            './components/Banners/BetBanners/BetBanners'
        ),
);

const CouponBanners = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'CouponBanners' */
            './components/Banners/CouponBanners/CouponBanners'
        ),
);

const PromotionBanners = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /*webpackChunkName: 'PromotionBanners' */
            './components/Banners/PromotionBanners/PromotionBanners'
        ),
);

const AuthLayout = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'AuthLayout' */
            './components/Auth/AuthLayout'
        ),
);

const LoginForm = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Login' */
            './components/Auth/Form/LoginForm'
        ),
);

const Otp = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Otp' */
            './components/Auth/Otp/Otp'
        ),
);

const Templates = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Templates' */
            './components/Templates/Templates'
        ),
);
const Weight = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Weight' */
            './components/Weight/Weight'
        ),
);
const Event = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Event' */
            './components/Event/Event'
        ),
);
const Monitoring = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Monitoring' */
            './components/Monitoring/Monitoring'
        ),
);
const QuickSearch = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Reports-QuickSearch' */
            './components/Reports/QuickSearch/QuickSearch'
        ),
);
const BetHistory = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Reports-BetsHistory' */
            './components/Reports/BetsHistory/BetsHistory'
        ),
);

const TicketOperationsHistory = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Ticket-Opertaions-History' */
            './components/TicketOperationsHistory/TicketOperationsHistory'
        ),
);

const BetsMonitor = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Reports-BetsMonitor' */
            './components/Reports/BetsMonitor/BetsMonitor'
        ),
);
const GamingActivity = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Reports-GamingActivity' */
            './components/Reports/GamingActivity/GamingActivity'
        ),
);
const Users = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'User' */
            './components/User/User'
        ),
);

const PrivateRoute = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'shared-PrivateRoute' */
            './components/shared/PrivateRoute/PrivateRoute'
        ),
);

const Messages = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Messages' */
            './components/Messages/Messages'
        ),
);

const ViewMessage = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'ViewMessage' */
            './components/Messages/ViewMessage/ViewMessage'
        ),
);

const Settlement = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Settlement' */
            './components/Settlement/Settlement'
        ),
);
const Tickets = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Tickets' */
            './components/Settlement/Tickets/Tickets'
        ),
);
const Markets = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Settlement' */
            './components/Settlement/Markets/Markets'
        ),
);

const CashoutBlock = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Settlement' */
            './components/CashoutBlock/CashoutBlock'
        ),
);

const Events = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Settlement' */
            './components/CashoutBlock/Events/Events'
        ),
);

const MarketsAndLeagues = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Settlement' */
            './components/CashoutBlock/MarktesAndLeagues/MarketsAndLeagues'
        ),
);

const Emails = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Emails' */
            './components/Emails/Emails'
        ),
);
const LiveTvConfig = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'LiveTvConfig' */
            './components/LiveTvConfig/LiveTvConfig'
        ),
);

const ServerErrors = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Translations-ServerErrors' */
            './components/Translations/ServerErrors/ServerErrors'
        ),
);

const PlayerSearch = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Player-Search' */
            './components/PlayerSearch/PlayerSearch'
        ),
);

const PlayerDetails = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Player-Details' */
            './components/PlayerDetails/PlayerDetails'
        ),
);

const DeclinedBetsHistory = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Declined Bets History' */
            './components/DeclinedBetsHistory/DeclinedBetsHistory'
        ),
);
const UserInterface = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'User Interface' */
            './components/Translations/UserInterface/UserInterface'
        ),
);

const PermissionGroups = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Permission Groups' */
            './components/PermissionGroups/PermissionGroups'
        ),
);

const LoginsHistory = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Logins History' */
            './components/LoginsHistory/LoginsHistory'
        ),
);

const AccountingReport = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Accounting Report' */
            './components/AccountingReport/AccountingReport'
        ),
);

const MoneyTransactions = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Money Transactions' */
            './components/MoneyTransactions/MoneyTransactions'
        ),
);

const PlayerSegmentation = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'PlayerSegmentation' */
            './components/PlayerSegmentation/PlayerSegmentation'
        ),
);

const PlayerSegmentationReport = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'PlayerSegmentationReport' */
            './components/PlayerSegmentationReport/PlayerSegmentationReport'
        ),
);

const NetCashReport = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Net Cash Report' */
            './components/NetCashReport/NetCashReport'
        ),
);

const RegistrationsHistory = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Registrations History' */
            './components/RegistrationsHistory/RegistrationsHistory'
        ),
);

const UpdateVersion = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Update Version' */
            './components/UpdateVersion/UpdateVersion'
        ),
);

const PlayerMassUpdate = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Player Mass Update' */
            './components/PlayerMassUpdate/PlayerMassUpdate'
        ),
);

const Banners = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Banners' */
            './components/Banners/Banners'
        ),
);

const FeaturedLinks = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Featured Links' */
            './components/FeaturedLinks/FeaturedLinks'
        ),
);
const PlayerActivityReport = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Reports-PlayerActivityReport' */
            './components/PlayerActivityReport/PlayerActivityReport'
        ),
);

const DepositsWithdrawals = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'DepositsWithdrawals' */
            './components/DepositsWithdrawals/DepositsWithdrawals'
        ),
);

const WithdrawalAutoprocessing = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'WithdrawalAutoprocessing' */
            './components/WithdrawalAutoprocessing/WithdrawalAutoprocessing'
        ),
);

const TaxReport = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Tax Report' */
            './components/TaxReport/TaxReport'
        ),
);

const OnlinePlayersReport = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Online Players Report' */
            './components/OnlinePlayersReport/OnlinePlayersReport'
        ),
);

const FrozenAccountsReport = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Frozen Accounts Report' */
            './components/FrozenAccountsReport/FrozenAccountsReport'
        ),
);

const PlayerSportsPerformance = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'SportsPerformance' */
            './components/SportsPerformance/SportsPerformance'
        ),
);

const Featured = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Featured' */
            './components/Featured/Featured'
        ),
);

const InactivePlayersReport = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Inactive-Players-Report' */
            './components/InactivePlayersReport/InactivePlayersReport'
        ),
);

const AuditTrailReport = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Audit Trail Report' */
            './components/AuditTrailReport/AuditTrailReport'
        ),
);

const BonusCreation = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Bonus Creation' */
            './components/BonusCreation/BonusCreation'
        ),
);

const Promotion = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Promotion' */
            './components/Promotion/Promotion'
        ),
);

const Promotions = React.lazy(
    () =>
        import(
            /* webpackPrefetch:true */
            /* webpackChunkName: 'Promotions' */
            './components/Promotions/Promotions'
        ),
);

const Bonuses = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Bonuses' */
            './components/Bonuses/Bonuses'
        ),
);

const PlayerBonusesReport = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Player Bonuses Report' */
            './components/PlayerBonusesReport/PlayerBonusesReport'
        ),
);

const BonusEngineMonitor = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Bonus Engine Monitor' */
            './components/BonusEngineMonitor/BonusEngineMonitor'
        ),
);
const GrandMassBonuses = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'GrandMassBonuses' */
            './components/GrandMassBonuses/GrandMassBonuses'
        ),
);

const BonusWageringReport = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Bonus Wagering Report' */
            './components/BonusWageringReport/BonusWageringReport'
        ),
);

const PromotionBonusOffers = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Promotion Bonus Offers' */
            './components/PromotionBonusOffers/PromotionBonusOffers'
        ),
);

const BulkSegmentUpdate = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Bulk Segment Update' */
            './components/BulkSegmentUpdate/BulkSegmentUpdate'
        ),
);

const MenuManagement = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'MenuManagement' */
            './components/MenuManagement/MenuManagement'
        ),
);

const PaymentMethods = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Payment Methods' */
            './components/PaymentMethods/PaymentMethods'
        ),
);

const BettingRules = React.lazy(
    () =>
        import(
            /*webpackPrefetch:true*/
            /* webpackChunkName: 'Betting Rules' */
            './components/BettingRules/BettingRules'
        ),
);

const AppRoutes = () => {
    // const checkAccess = useAccess();
    const dispatch = useDispatch();
    const location = useLocation();
    const { pathname } = location;
    const showDashboardLayout = pathname !== ROUTES.LOGIN.path && pathname !== ROUTES.OTP.path;
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    const isFetching = useSelector(state => state.auth.isFetching);

    useEffect(() => {
        const isTranslationMode = location.search.includes('translation-mode=on');

        if (isTranslationMode) {
            dispatch(changeTranslationMode(isTranslationMode));
        }
    }, []);

    const routes = (
        <Suspense fallback={<Spin className={'fallback-spin'} />}>
            <Routes>
                <Route element={<AuthLayout />}>
                    <Route exact path={ROUTES.LOGIN.path} element={<LoginForm />} />
                    <Route exact path={ROUTES.OTP.path} element={<Otp />} />
                </Route>
                {/*<PrivateRoute isAuthenticated={isFetching || isAuthenticated} exact path={ROUTES.HOME.path} component={Templates} />*/}
                <Route element={<PrivateRoute isAuthenticated={isFetching || isAuthenticated} />}>
                    <Route path={ROUTES.TEMPLATES.path} element={<Templates />}>
                        <Route path={ROUTES.TEMPLATES_MBN.path} element={<Mbn />} />
                        <Route path={ROUTES.TEMPLATES_MARKET_GROUPS.path} element={<MarketGroups />} />
                        <Route path={ROUTES.TEMPLATES_BET_ACCEPTANCE.path} element={<BetAcceptanceTime />} />
                        <Route path={ROUTES.TEMPLATES_LOCK_COMBINATIONS.path} element={<CombinationLocks />} />
                        <Route path={ROUTES.TEMPLATES_MARKET_DESCRIPTIONS.path} element={<MarketDescriptions />} />
                    </Route>
                    <Route path={ROUTES.WEIGHT.path} element={<Weight />}>
                        <Route path={ROUTES.SPORTS.path} element={<Sports />} />
                        <Route path={ROUTES.CATEGORIES.path} element={<Categories />} />
                        <Route path={ROUTES.LEAGUES.path} element={<Leagues />} />
                    </Route>
                    <Route path={ROUTES.EVENTS_COMMON.path} element={<Monitoring />} />
                    <Route path={ROUTES.VIEW_EVENT.path} element={<Event />} />
                    <Route path={ROUTES.BETS_MONITOR.path} element={<BetsMonitor />} />
                    <Route path={ROUTES.SETTLEMENT.path} element={<Settlement />}>
                        <Route path={ROUTES.SETTLEMENT_TICKETS.path} element={<Tickets />} />
                        <Route path={ROUTES.SETTLEMENT_MARKETS.path} element={<Markets />} />
                    </Route>
                    <Route path={ROUTES.CASHOUT_BLOCK.path} element={<CashoutBlock />}>
                        <Route path={ROUTES.CASHOUT_BLOCK_EVENTS.path} element={<Events />} />
                        <Route path={ROUTES.CASHOUT_BLOCK_MARKETS_AND_LEAGUES.path} element={<MarketsAndLeagues />} />
                    </Route>
                    <Route path={ROUTES.SPORTS_PERFORMANCE.path} element={<PlayerSportsPerformance />} />
                    <Route path={ROUTES.QUICK_SEARCH.path} element={<QuickSearch />} />
                    <Route path={'/bets-history-2'} element={<BetHistory />} />
                    <Route path={ROUTES.TICKET_OPERATIONS_HISTORY.path} element={<TicketOperationsHistory />} />
                    <Route path={'/gaming-activity-2'} element={<GamingActivity />} />
                    <Route path={ROUTES.LOGINS_HISTORY.path} element={<LoginsHistory />} />
                    <Route path={ROUTES.ACCOUNTING_REPORT.path} element={<AccountingReport />} />
                    <Route path={ROUTES.TAX_REPORT.path} element={<TaxReport />}>
                        <Route path={ROUTES.TAX_ON_TURNOVER_REPORT.path} element={<TaxOnTurnoverReport />} />
                        <Route path={ROUTES.TAX_ON_RETURN_REPORT.path} element={<TaxOnReturnReport />} />
                    </Route>
                    <Route path={ROUTES.ONLINE_PLAYERS_REPORT.path} element={<OnlinePlayersReport />} />
                    <Route path={ROUTES.DECLINED_BETS_HISTORY.path} element={<DeclinedBetsHistory />} />
                    <Route path={ROUTES.NET_CASH_REPORT.path} element={<NetCashReport />} />
                    <Route path={ROUTES.REGISTRATION_HISTORY.path} element={<RegistrationsHistory />} />
                    <Route path={ROUTES.FROZEN_ACCOUNTS_REPORT.path} element={<FrozenAccountsReport />} />
                    <Route path={ROUTES.INACTIVE_PLAYERS_REPORT.path} element={<InactivePlayersReport />} />
                    <Route path={ROUTES.AUDIT_TRAIL_REPORT.path} element={<AuditTrailReport />} />
                    <Route path={'/accounts/users-2'} element={<Users />} />
                    <Route path={ROUTES.MESSAGE_LIST.path} element={<Messages />} />
                    <Route path={ROUTES.VIEW_MESSAGE.path} element={<ViewMessage />} />
                    <Route path={ROUTES.EMAILS.path} element={<Emails />}>
                        <Route path={ROUTES.EMAIL_ADDRESSES.path} element={<Addresses />} />
                        <Route path={ROUTES.EMAIL_GROUPS.path} element={<Groups />} />
                    </Route>
                    <Route path={ROUTES.SERVER_ERRORS_ONLINE.path} element={<ServerErrors />} />
                    <Route path={ROUTES.USER_INTERFACE_ONLINE.path} element={<UserInterface />} />
                    <Route path={ROUTES.BANNERS.path} element={<Banners />}>
                        <Route path={ROUTES.BET_BANNER.path} element={<BetBanners />} />
                        <Route path={ROUTES.COUPON_BANNER.path} element={<CouponBanners />} />
                        <Route path={ROUTES.PROMOTION_BANNER.path} element={<PromotionBanners />} />
                    </Route>
                    <Route path={ROUTES.FEATURED_LINKS.path} element={<FeaturedLinks />} />
                    <Route path={ROUTES.FEATURED.path} element={<Featured />} />
                    <Route path={ROUTES.UPDATE_VERSION.path} element={<UpdateVersion />} />
                    <Route path={ROUTES.DEPOSITS_WITHDRAWALS.path} element={<DepositsWithdrawals />} />
                    <Route path={ROUTES.WITHDRAWAL_AUTOPROCESSING.path} element={<WithdrawalAutoprocessing />} />
                    <Route path={ROUTES.PLAYER_SEARCH.path} element={<PlayerSearch />} />
                    <Route path={ROUTES.PLAYER_MASS_UPDATE.path} element={<PlayerMassUpdate />} />
                    <Route path={ROUTES.MONEY_TRANSACTIONS.path} element={<MoneyTransactions />} />
                    <Route path={ROUTES.PLAYER_ACTIVITY_REPORT.path} element={<PlayerActivityReport />} />
                    <Route path={ROUTES.PLAYER_SEGMENTATION.path} element={<PlayerSegmentation />} />
                    <Route path={ROUTES.PLAYER_SEGMENTATION_REPORT.path} element={<PlayerSegmentationReport />} />
                    <Route path={ROUTES.PLAYER_DETAILS.path} element={<PlayerDetails />} />
                    <Route path={ROUTES.PROMOTION_CREATION.path} element={<Promotion />} />
                    <Route path={ROUTES.PROMOTION_DETAILS.path} element={<Promotion />} />
                    <Route path={ROUTES.PROMOTIONS.path} element={<Promotions />} />
                    <Route path={ROUTES.BONUS_CREATION.path} element={<BonusCreation />} />
                    <Route path={ROUTES.BONUSES.path} element={<Bonuses />} />
                    <Route path={ROUTES.PLAYER_BONUSES_REPORT.path} element={<PlayerBonusesReport />} />
                    <Route path={ROUTES.BONUS_ENGINE_MONITOR.path} element={<BonusEngineMonitor />} />
                    <Route path={ROUTES.GRAND_MASS_BONUSES.path} element={<GrandMassBonuses />} />
                    <Route path={ROUTES.BONUS_WAGERING_REPORT.path} element={<BonusWageringReport />} />
                    <Route path={ROUTES.PROMOTION_BONUS_OFFERS.path} element={<PromotionBonusOffers />} />
                    <Route path={ROUTES.BULK_SEGMENT_UPDATE.path} element={<BulkSegmentUpdate />} />
                    <Route path={ROUTES.MENU_MANAGEMENT.path} element={<MenuManagement />} />
                    <Route path={ROUTES.PAYMENT_METHODS.path} element={<PaymentMethods />} />
                    <Route path={ROUTES.BETTING_RULES.path} element={<BettingRules />} />
                    {/*<Route path={'/accounts/permission-groups'} element={<PermissionGroups />} />*/}
                </Route>
            </Routes>
        </Suspense>
    );

    return showDashboardLayout ? <Layout>{routes}</Layout> : routes;
};

export default AppRoutes;
